import React from 'react'
import injectSheet from 'react-jss'
import styles from './trainings-table.styles'
import { Table, HeadCell } from 'pobble-components/dist/table'
import TrainingsEntry from './trainings-entry/trainings-entry.container'

const TrainingsTable = ({ classes, trainings }) => (
  <Table>
    <thead>
      <tr>
        <HeadCell className={classes.left}>Thumb</HeadCell>
        <HeadCell className={classes.left}>Date</HeadCell>
        <HeadCell className={classes.left}>Owner</HeadCell>
        <HeadCell className={classes.titleCell}>Title</HeadCell>
        <HeadCell className={classes.titleCell}>Age Group</HeadCell>
        {/*<HeadCell className={classes.left}>Student</HeadCell>*/}
        {/*<HeadCell className={classes.center}>Conclusion</HeadCell>*/}
      </tr>
    </thead>
    <tbody>
      {trainings.map(training => (
        <TrainingsEntry key={training.id} id={training.id} />
      ))}
    </tbody>
  </Table>
)

export default injectSheet(styles)(TrainingsTable)
